export const DEFAULT_POS = () => ({ top: 140, left: Math.max(20, (window.innerWidth - 480) / 2) });
export const DEFAULT_GEO = () => ({ posX: 200, posY: 140, width: 480, height: 460 });

export const TABS = {
    START: 'start',
    PROPERTIES: 'properties',
    IMPORT: 'import',
    FILES: 'files',
    BODY: 'body',
};

// zie UmlSchemaConfigDlg.txt: TABS_SX
export const TABS_SX = {
    borderBottom: '0.5px solid var(--jx-border)',
    '& .MuiTab-root': {
        color: 'var(--jx-muted)',
        fontSize: 13,
        textTransform: 'none',
        minWidth: 0,
        px: 2,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
    },
    '& .Mui-selected': { color: 'var(--jx-accent)' },
    '& .MuiTabs-indicator': { bgcolor: 'var(--jx-accent)', height: 1.5 },
};
